<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlan?: getDeliveryPlanVehicleInformation;
}>();
</script>
<template>
  <v-col cols="3">
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.mergeForm.carNumber') }}
      </span>
      {{ props.deliveryPlan?.car_number }}
    </div>
    <div>
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.mergeForm.driver') }}
      </span>
      {{ props.deliveryPlan?.driver?.full_name }}
    </div>
  </v-col>
</template>
